import clsx from "clsx";
import { useState, type ImgHTMLAttributes } from "react";

type SkeletonImageProps = {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt" | "className">;

export function SkeletonImage({
  src,
  alt,
  className,
  imgClassName,
  ...rest
}: SkeletonImageProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={clsx("relative overflow-hidden", className)}>
      {!loaded && (
        <div
          aria-hidden
          className="absolute inset-0 animate-pulse bg-[#f3eee9]"
        />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className={clsx(
          "h-full w-full object-cover transition-opacity duration-300",
          loaded ? "opacity-100" : "opacity-0",
          imgClassName,
        )}
        {...rest}
      />
    </div>
  );
}
